import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

// 로그인(authorization_code 복귀) 직후인지 여부 (로그인 직후 1회성 신호)
// 온보딩 첫 화면(이메일 등록/약관) 진입 자격 + 약관 페이지 이탈 판정에 사용
// (온보딩 첫 화면 도달 시 false 로 소비된다)
export const isJustLoggedInState = atom<boolean>({
  key: "isJustLoggedInState",
  default: false,
});

const { persistAtom } = recoilPersist({ key: "court.agreement" });

export type AgreementCheckResult = { memberNo: string; required: boolean };

/** 약관 동의 판정을 localStorage 에 보존한다 (Taap과 통일).
 * - 로그인 시점에 1회 확인
 * - null = 아직 확인되지 않음
 *   - memberNo 로 현재 회원과의 일치를 검증해 회원 전환, STARTER -> MEMBER로 승급 시 자동으로 재조회
 * - 신규 로그인 시 Container.onRedirect에서 null 로 무효화하여 개정약관을 재검증한다.
 */
export const agreementCheckResultState = atom<AgreementCheckResult | null>({
  key: "agreementCheckResultState",
  default: null,
  effects_UNSTABLE: [persistAtom],
});

/** 폰 인증 회원이 입력한 가입 이메일 (약관 페이지의 STARTER => MEMBER 처리에서 patchJoin 에 사용)
 * - 비영속: 새로고침/탭종료 시 소실 (약관 미동의 = 비로그인 정책)
 */
export const pendingJoinEmailState = atom<string | null>({
  key: "pendingJoinEmailState",
  default: null,
});
